import { TEXT } from './Typography';
interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  className?: string;
}

export default function LoadingSpinner({
  message,
  size = 'md',
  fullScreen = false,
  className = '',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-16 w-16',
  };

  const spinner = (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-blue-600`}
        role="status"
        aria-label="Loading"
      />
      {message && <p className={TEXT.bodyMuted}>{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex h-full min-h-[400px] w-full items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
}
